import GLOBAL_URL from '../../url';
const WAVELIGHT_URL = `${GLOBAL_URL}/api/wavelight-backend/auth`;
export default WAVELIGHT_URL;
